var isSymbol = {};
export {
  isSymbol as __exports
};
//# sourceMappingURL=isSymbol.js.map
